export const TYPE_CPF = 1
export const TYPE_CNPJ = 2

export const ORIGIN_WEB = "WEB"
export const ORIGIN_MOBILE = "MOBILE"
export const ORIGIN_APP = "APP"

export const PAP_FLOW = 1
export const WEBDEALER_FLOW = 2

export const ADRESS_CATEGORIES = [
  { value: 1, text: "Condomínio" },
  { value: 2, text: "Casa" },
  { value: 3, text: "Prédio Comercial" }
]

export const SHIPPING_OPTIONS = [
  { value: 1, name: "Papel", slug: "PAPEL", searchable: "PAPER" },
  { value: 2, name: "E-mail", slug: "EMAIL", searchable: "EMAIL" },
  {
    value: 3,
    name: "Entrega Presencial",
    slug: "PRESENCIAL",
    searchable: "PRESENCIAL"
  }
]

export const SHIPPING_WHATSAPP = {
  value: 4,
  name: "Whatsapp",
  slug: "WHATSAPP",
  searchable: "WHATSAPP"
}

export const ALL_SHIPPING_OPTIONS = [
  ...SHIPPING_OPTIONS,
  SHIPPING_WHATSAPP
]

export const BANK_SLIP = {
  value: 1,
  name: "Boleto Bancário",
  slug: "BOLETO",
  searchable: "BANK_SLIP"
}

export const DEBIT = {
  value: 2,
  name: "Débito Automático",
  slug: "DEBITO_AUTOMATICO",
  searchable: "DEBIT"
}

export const BOOKLET = {
  value: 3,
  name: "Carnê",
  slug: "CARNE",
  searchable: "BOOKLET"
}

export const PAYMENT_OPTIONS = [BANK_SLIP, DEBIT, BOOKLET]

export const FIND_VALUE_BY_SEARCHABLE = (options, searchable) => {
  const option = options.find(opt =>
    [opt.name, opt.slug, opt.searchable].includes(searchable)
  )
  return option || null
}

export const COMPANY_TYPES = [
  { value: 1, text: "Empresa LTDA" },
  { value: 2, text: "Sociedade Anônima" },
  { value: 3, text: "Sindicatos, Cooperativas e Associações" },
  { value: 4, text: "Firma Individual" },
  { value: 5, text: "Igrejas" },
  { value: 6, text: "Condomínio" },
  { value: 7, text: "Produtor Rural" }
]

export const STATES = [
  { value: 0, text: "Selecione...", acronym: "" },
  { value: 1, text: "Acre", acronym: "AC" },
  { value: 2, text: "Alagoas", acronym: "AL" },
  { value: 3, text: "Amazonas", acronym: "AM" },
  { value: 4, text: "Amapá", acronym: "AP" },
  { value: 5, text: "Bahia", acronym: "BA" },
  { value: 6, text: "Ceará", acronym: "CE" },
  { value: 7, text: "Distrito Federal", acronym: "DF" },
  { value: 8, text: "Espírito Santo", acronym: "ES" },
  { value: 9, text: "Goiás", acronym: "GO" },
  { value: 10, text: "Maranhão", acronym: "MA" },
  { value: 11, text: "Minas Gerais", acronym: "MG" },
  { value: 12, text: "Mato Grosso do Sul", acronym: "MS" },
  { value: 13, text: "Mato Grosso", acronym: "MT" },
  { value: 14, text: "Pará", acronym: "PA" },
  { value: 15, text: "Paraíba", acronym: "PB" },
  { value: 16, text: "Pernambuco", acronym: "PE" },
  { value: 17, text: "Piauí", acronym: "PI" },
  { value: 18, text: "Paraná", acronym: "PR" },
  { value: 19, text: "Rio de Janeiro", acronym: "RJ" },
  { value: 20, text: "Rio Grande do Norte", acronym: "RN" },
  { value: 21, text: "Rondônia", acronym: "RO" },
  { value: 22, text: "Roraima", acronym: "RR" },
  { value: 23, text: "Rio Grande do Sul", acronym: "RS" },
  { value: 24, text: "Santa Catarina", acronym: "SC" },
  { value: 25, text: "Sergipe", acronym: "SE" },
  { value: 26, text: "São Paulo", acronym: "SP" },
  { value: 27, text: "Tocantins", acronym: "TO" }
]

export const STATE_REGISTRATION_MASK = [
  {
    idState: 0,
    textState: "Selecione",
    mask: null,
    placeHolder: "Inscrição Estadual",
    maxLength: 0,
    minLengthClean: 0
  },
  {
    idState: 1,
    textState: "Acre",
    mask: ["##.###.###/###-##"],
    placeHolder: "__.___.___/___-__",
    maxLength: 17,
    minLengthClean: 13
  },
  {
    idState: 2,
    textState: "Alagoas",
    mask: ["#########"],
    placeHolder: "_________",
    maxLength: 9,
    minLengthClean: 9
  },
  {
    idState: 3,
    textState: "Amazonas",
    mask: ["##.###.###-#"],
    placeHolder: "__.___.___-_",
    maxLength: 12,
    minLengthClean: 9
  },
  {
    idState: 4,
    textState: "Amapá",
    mask: ["#########"],
    placeHolder: "_________",
    maxLength: 9,
    minLengthClean: 9
  },
  {
    idState: 5,
    textState: "Bahia",
    mask: ["######-##"],
    placeHolder: "______-__",
    maxLength: 9,
    minLengthClean: 8
  },
  {
    idState: 6,
    textState: "Ceará",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 7,
    textState: "Distrito Federal",
    mask: ["###########-##"],
    placeHolder: "___________-__",
    maxLength: 14,
    minLengthClean: 13
  },
  {
    idState: 8,
    textState: "Espírito Santo",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 9,
    textState: "Goiás",
    mask: ["##.###.###-#"],
    placeHolder: "__.___.___-_",
    maxLength: 12,
    minLengthClean: 9
  },
  {
    idState: 10,
    textState: "Maranhão",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 11,
    textState: "Minas Gerais",
    mask: ["###.###.###/####"],
    placeHolder: "___.___.___/____",
    maxLength: 16,
    minLengthClean: 13
  },
  {
    idState: 12,
    textState: "Mato Grosso do Sul",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 13,
    textState: "Mato Grosso",
    mask: ["##########-#"],
    placeHolder: "__________-_",
    maxLength: 16,
    minLengthClean: 13
  },
  {
    idState: 14,
    textState: "Pará",
    mask: ["##-######-#"],
    placeHolder: "__-______-_",
    maxLength: 11,
    minLengthClean: 9
  },
  {
    idState: 15,
    textState: "Paraíba",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 16,
    textState: "Pernambuco",
    mask: ["#######-##"],
    placeHolder: "_______-__",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 17,
    textState: "Piauí",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 18,
    textState: "Paraná",
    mask: ["###.#####-##"],
    placeHolder: "___._____-__",
    maxLength: 12,
    minLengthClean: 10
  },
  {
    idState: 19,
    textState: "Rio de Janeiro",
    mask: ["##.###.##-#"],
    placeHolder: "__.___.__-_",
    maxLength: 11,
    minLengthClean: 8
  },
  {
    idState: 20,
    textState: "Rio Grande do Norte",
    mask: ["##.###.###-#"],
    placeHolder: "__.___.___._",
    maxLength: 12,
    minLengthClean: 9
  },
  {
    idState: 21,
    textState: "Rondônia",
    mask: ["#############-#"],
    placeHolder: "_____________-_",
    maxLength: 15,
    minLengthClean: 14
  },
  {
    idState: 22,
    textState: "Roraima",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 23,
    textState: "Rio Grande do Sul",
    mask: ["###/#######"],
    placeHolder: "___/_______",
    maxLength: 11,
    minLengthClean: 10
  },
  {
    idState: 24,
    textState: "Santa Catarina",
    mask: ["###.###.###"],
    placeHolder: "___.___.___",
    maxLength: 11,
    minLengthClean: 9
  },
  {
    idState: 25,
    textState: "Sergipe",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 26,
    textState: "São Paulo",
    mask: ["###.###.###.###"],
    placeHolder: "___.___.___.___",
    maxLength: 15,
    minLengthClean: 12
  },
  {
    idState: 27,
    textState: "Tocantins",
    mask: ["##########-#", "########-#"],
    placeHolder: "Inscrição Estadual",
    maxLength: 12,
    minLengthClean: 9
  }
]

export const DUE_DATES = ["05", "10", "15", "20", "25", "30"]

export const BANKS = [
  { value: "", id: "", text: "Selecione..." },
  { value: 1, id: "001", text: "BANCO DO BRASIL S/A" },
  { value: 2, id: "275", text: "BANCO REAL S/A" },
  { value: 3, id: "756", text: "BANCOOB S/A" },
  { value: 4, id: "047", text: "BANESE" },
  { value: 5, id: "024", text: "BANESTES S/A" },
  { value: 6, id: "041", text: "BANRISUL" },
  { value: 7, id: "748", text: "BANSICREDI S/A" },
  { value: 8, id: "237", text: "BRADESCO S/A" },
  { value: 9, id: "104", text: "CAIXA ECONOMICA FED" },
  { value: 10, id: "745", text: "CITIBANK" },
  { value: 11, id: "399", text: "HSBC BANK BRASIL S/A" },
  { value: 12, id: "341", text: "ITAU S/A" },
  { value: 13, id: "389", text: "MERCANTIL DO BRASIL" },
  { value: 14, id: "422", text: "SAFRA" },
  { value: 15, id: "409", text: "UNIBANCO S/A" }
]

export const PROVIDER_ID = 1

export const PENDENCY_TYPES = [
  { type: "VENDEDOR", id: 4 },
  { type: "BIOMETRIA", id: 5 },
  { type: "BKO", id: 6 },
  { type: "SISTEMICA", id: 7 }
]

export const ORDER_STATUS = [
  {
    id: "category-3",
    type: "finished",
    icon: "check-circle",
    title: "Finalizado",
    substatus: [
      {
        id: 2,
        type: "Finalizado"
      },
      {
        id: 12,
        type: "Cancelado"
      },
      {
        id: 13,
        type: "Desistência"
      },
      {
        id: 26,
        type: "Reprovado",
        indicator: "reproved"
      }
    ]
  },
  {
    id: "category-1",
    type: "pending",
    icon: "alert-triangle",
    title: "Pendente",
    substatus: [
      {
        id: 4,
        type: "Vendedor"
      },
      {
        id: 5,
        type: "Biometria"
      },
      {
        id: 6,
        type: "BKO"
      },
      {
        id: 7,
        type: "Sistema"
      },
      {
        id: 8,
        type: "Agendamento"
      },
      {
        id: 9,
        type: "Integração"
      },
      {
        id: 11,
        type: "Aprovação"
      },
      {
        id: 18,
        type: "Cobertura"
      },
      {
        id: 19,
        type: "Crédito"
      },
      {
        id: 22,
        type: "Engenharia"
      },
      {
        id: 25,
        type: "Aceite do Termo"
      }
    ]
  },
  {
    id: "category-2",
    type: "awaiting",
    icon: "clock",
    title: "Aguardando",
    substatus: [
      {
        id: 1,
        type: "Auditoria"
      },
      {
        id: 10,
        type: "Biometria"
      }
    ]
  },
  {
    id: 3,
    type: "in-progress",
    icon: "settings",
    title: "Em Andamento"
  },
  {
    id: "category-4",
    type: "installation",
    icon: "tool",
    title: "Instalação",
    substatus: [
      {
        id: 14,
        type: "Aguardando"
      },
      {
        id: 15,
        type: "Cancelada"
      },
      {
        id: 16,
        type: "Concluída"
      }
    ]
  }
]

export const SERVICE_STATUS = [
  {
    id: 1,
    title: "Aguardando",
    type: "waiting"
  },
  {
    id: 2,
    title: "Aprovado",
    type: "approved"
  },
  {
    id: 3,
    title: "Reprovado",
    type: "disapproved"
  },
  {
    id: 4,
    title: "Desistência",
    type: "abandoned"
  },
  {
    id: 5,
    title: "Cancelado",
    type: "canceled"
  }
]
export const MOVEMENTS = [
  { id: 1, text: "Inclusão da OS" },
  { id: 2, text: "Aguardando Distribuição" },
  { id: 3, text: "Aguardando Execução" },
  { id: 4, text: "Reagendamento" },
  { id: 5, text: "Cancelamento" },
  { id: 6, text: "Executada" }
]

export const ORDER_FINISH_BUTTON_TEXT = {
  default: "Enviar e realizar biometria remota",
  algar: "Enviar biometria"
}

export const DEFAULT_ICON_FOR_OPTIONS_CATEGORIES_FILTER = "noIcon"

export const OPTIONS_CATEGORIES_FILTER = [
  { name: "Streaming", icon: "streaming" },
  { name: "Esportes", icon: "sport" },
  { name: "Saúde e Bem Estar", icon: "health" },
  { name: "E-Books", icon: "star" },
  { name: "Outros", icon: "noIcon" },
  { name: "Segurança Digital", icon: "shield" }
]

export const ICONS_CATEGORIES_FILTER = {
  star: require("@hub/order/src/assets/images/star.svg"),
  streaming: require("@hub/order/src/assets/images/streaming.svg"),
  sport: require("@hub/order/src/assets/images/sport.svg"),
  health: require("@hub/order/src/assets/images/health.svg"),
  shield: require("@hub/order/src/assets/images/shield.svg"),
  noIcon: require("@hub/order/src/assets/images/other-option.svg")
}

export const TYPES_OFFERS_PLANS = {
  plan: "PLAN",
  packaged: "PACKAGED",
  serviceAdditional: "SERVICE_ADDITIONAL"
}

export const CLIENT_TYPE = [
  { text: "FISICA", value: 1 },
  { text: "JURIDICA", value: 2 }
]

export const MOVEMENT_TYPES = {
  alta: "Alta",
  migration: "Migração",
  upgrade: "Upgrade",
  downgrade: "Downgrade",
}

export const ROUTES_OFFERS = ["offers-separate", "offers-combos", "offers"]

export const ROUTES_NAMES = {
  ROUTE_OFFERS_SEPARATE: "offers-separate",
  ROUTE_OFFERS_COMBOS: "offers-combos",
  ROUTE_OFFERS: "offers",
  ROUTE_ADDITIONAL_SERVICE: "additional-service",
  ROUTE_CUSTOMIZE_SERVICE: "customize-service",
  ROUTE_AVAILABILITY_MAP: "availability-map",
}

export const ADDRESS_TYPE = {
  COMMERCIAL: "COMERCIAL",
  RESIDENTIAL: "RESIDENCIAL"
}

export const PAYMENT_TYPE = {
  DEBIT: "DEBITO_AUTOMATICO",
  BILLET: "BOLETO"
}

export const PERSON_TYPE = {
  INDIVIDUAL: "FISICA",
  LEGAL: "JURIDICA"
}

export const CONTACT_TYPE = {
  CELLPHONE: "CELULAR",
  LANDLINE: "FIXO",
  ALTERNATIVE: "CELULAR_ALTERNATIVO",
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP"
}

export const GENDER_MAP = {
  F: "Feminino",
  M: "Masculino",
  N: "Nenhum"
}

export const GENDER_OPTIONS = [
  {
    label: "M",
    name: "gender",
    title: "Masculino"
  },
  {
    label: "F",
    name: "gender",
    title: "Feminino"
  }
]

export const OTHER_GENDER = {
  label: "O",
  name: "gender",
  title: "Nenhum"
}

export const STATUS_COVERAGE_ANALYSIS = {
  NOT_REALIZED: 1,
  APPROVED: 2,
  DISAPPROVED: 3,
  CITY_WITHOUT_MAPPING: 4
}

export const STATUS_CREDIT_ANALYSIS = {
  NOT_REALIZED: 1,
  APPROVED: 2,
  DISAPPROVED: 3,
  NECESSARY_MANUAL_ANALYSIS: 4,
  INTERNAL_DEBIT: 5
}

export const ANALYSIS_ATTEMPT_LIMIT = 3

export const ANALYSIS_MESSAGES = {
  ERROR: "Erro na analise de crédito!"
}

export const MARITAL_STATUS_OPTIONS = [
  { text: "Solteiro(a)", value: "SOLTEIRO" },
  { text: "Casado(a)", value: "CASADO" },
  { text: "Divorciado(a)", value: "DIVORCIADO" },
  { text: "Viúvo(a)", value: "VIUVO" },
  { text: "Separado(a)", value: "SEPARADO" },
  { text: "União Estável", value: "UNIAO_ESTAVEL" }
]

export const ROUTE_ORDER = "order"

export const ALGAR_CODE = "ALG"

export const LOCATION_TYPE_OPTIONS = [
  {
    title: "Urbano",
    label: "URBANO",
    name:"location-type"
  },
  {
    title: "Rural",
    label: "RURAL",
    name: "location-type"
  }
]

export const PORTABILITY_OPTIONS = [
  {
    label: true,
    name: "portability_true",
    title: "Sim"
  },
  {
    label: false,
    name: "portability_false",
    title: "Não"
  }
]

export const SCHOOLED_OPTIONS = [
  {
    label: "yes",
    name: "schooled",
    title: "Sim"
  },
  {
    label: "no",
    name: "schooled",
    title: "Não"
  }
]

export const SAME_ADDRESS_OPTIONS = [
  {
    label: "yes",
    name: "isSameAddress",
    title: "Sim"
  },
  {
    label: "no",
    name: "isSameAddress",
    title: "Não"
  }
]

export const SIM_CARD_TYPE_OPTIONS = [
  { label: "3499", title: "eSIM", name: "simcard_type_3499" },
  { label: "3500", title: "SimCard", name: "simcard_type_3500" }
]

export const DELIVERY_TYPES = {
  logistics: "183",
  inPerson: "182"
}

export const DELIVERY_TYPE_OPTIONS = [
  { label: DELIVERY_TYPES.logistics, title: "Logística", name: "delivery_type_183" },
  { label: DELIVERY_TYPES.inPerson, title: "Presencial", name: "delivery_type_182" }
]

export const CONTRACT_TYPES = [
  { value: 3, text: "Residência" },
  { value: 4, text: "PME" }
  //{ value: 5, text: "Corporativo" }
]

export const SHIPPING_TYPES = [
  {
    value: 1,
    text: "Papel",
    name: "Papel",
    parameter: "PAPEL",
    searchable: "PAPER",
    slug: "PAPEL"
  },
  {
    value: 2,
    text: "E-mail",
    name: "E-mail",
    parameter: "EMAIL",
    searchable: "EMAIL",
    slug: "EMAIL"
  }
]

export const WALLET_OPTIONS = [
  { text: "Selecione...", value: "" },
  // { text: "Ideia (Tecnet)", value: 3 },
  { text: "Conexão", value: 4 },
  { text: "Outcenter", value: 6 },
  // { text: "Webnet", value: 7 },
  { text: "Starweb", value: 9 },
  { text: "Cabo", value: 12 },
  { text: "Multplay", value: 13 },
  { text: "Webby", value: 14 },
  { text: "Azza", value: 16},
]

export const TOAST_MESSAGES_BY_COVERAGE_STATUS = {
  [STATUS_COVERAGE_ANALYSIS.NOT_REALIZED]: {
    type: "error",
    title: "Atenção! Falha. Não foi possível consultar a disponibilidade."
  },
  [STATUS_COVERAGE_ANALYSIS.APPROVED]: {
    type: "success",
    title: "Análise Aprovada!"
  },
  [STATUS_COVERAGE_ANALYSIS.DISAPPROVED]: {
    type: "error",
    title: "O Endereço consultado não possui Cobertura."
  }
}

export const DEFAULT_FIRST_OPTION = { text: "Selecione ...", value: 0 }

export const EDIT_FLOW_KEY = "edit_flow"

export const ICON_COLORS = {
  base: "#FF530D",
  sucess: "#33691E",
  white: "#FFFFFF"
}

export const CHECK_ICON = require("@hub/order/src/assets/images/check.svg")

export const MAX_INTERVAL_DAYS = 30

export const DOCUMENT_TYPE_CPF = "cpf"

export const DOCUMENT_TYPE_CNPJ = "cnpj"

export const BIOMETRY_ORIGINS = {
  LINK: "li",
  QR_CODE: "qc"
}

export const CONTACTS_TYPE = {
  landline: "FIXO",
  cellphone: "CELULAR",
  email: "EMAIL",
  anotherContact: "CELULAR_ALTERNATIVO"
}

export const BAD_REQUEST_CODE = 404
export const NOT_FOUND_ERROR_CODE = 400
export const UNPROCESSABLE_CONTENT = 422


export const TYPES_OFFERS = {
  movel: "Móvel",
  fixa: "Fixa",
  tv: "TV"
}

export const LIST_OPTIONS_OFFERS = [
  {
    isActive: true,
    title: "Combos",
    icon: "layers",
    routeName: "offers-combos"
  },
  {
    isActive: false,
    title: "Avulsas",
    icon: "shopping-bag",
    routeName: "offers-separate"
  }
]

export const OPTIONS_OFFERS_SEPARATE = [
  {
    isActive: true,
    title: "Telefonia Móvel",
    icon: "smartphone",
    slug: ""
  },
  {
    isActive: false,
    title: "Tv por assinatura",
    icon: "tv",
    slug: ""
  },
  {
    isActive: false,
    title: "Telefonia Fixa",
    icon: "phone",
    slug: ""
  }
]

export const ICONS_NAME_OPTIONS_OFFERS = {
  Fixa: 'wifi',
  Internet: 'wifi',
  Móvel: 'smartphone',
  TV: 'tv',
  'Voz Fixa': 'phone',
  Pacote: 'shopping-bag'
}

export const CONTACT_DUPLICATED_TYPE = {
  email: "EMAIL",
  cellphone: "CELULAR",
  both: "BOTH"
}

export const CONTACT_DUPLICATED_TEXT = {
  EMAIL: "email",
  CELULAR: "cellphone",
  BOTH: "both"
}

export const CLIENT_SEARCH_ROUTE_NAME = "client-search"
export const SELECT_POS_ROUTE_NAME = "select-pos"
export const COMPANY_INFO_CAME_FROM = {
  manualInput: 1,
  bepeople: 2
}

export const LOCKABLE_COMPANY_FIELDS = {
  companyType: "person_legal_type",
  companyState: "state_id"
}

export const ADDRESS_GROUP_COMPLEMENT_TYPE = "UGE - Unidade Grupo endereço"

export const BIOMETRY_RESEND_STEPS = {
  channel: "channel",
  confirm: "confirm",
  blocked: "blocked",
  success: "success"
}

export const BIOMETRY_RESEND_CHANNELS = {
  email: "email",
  whatsapp: "whatsapp"
}

export const CHANNELS_CONFIG = {
  [BIOMETRY_RESEND_CHANNELS.email]: {
    label: "E-mail",
    description: "Enviar por e-mail",
    icon: ["fa", "envelope"],
    class: "email"
  },

  [BIOMETRY_RESEND_CHANNELS.whatsapp]: {
    label: "WhatsApp",
    description: "Enviar via WhatsApp",
    icon: ["fab", "whatsapp"],
    class: "whatsapp"
  }
}

export const ADDON_TYPES = {
  dependents: 1,
  additionalPoints: 2,
}

export const SALE_STATUS = {
  waiting: "Aguardando"
}

export const SALE_SUB_STATUS = {
  waiting_payment: "Pagamento"
}

export const DOCUMENTS_LENGTH = {
  cpf: 11,
  cnpj: 14
}
